/**
 * other
 */
'use strict';
import AppVue from './_modules/other/app_vue';

window.st50Modules = [];

document.addEventListener('DOMContentLoaded', () => {
  new AppVue('benefit');
}, false);

window.addEventListener('load', () => {
  //document.getElementById('c-wrapper').style.visibility = 'visible';
}, false);

window.addEventListener('unload', () => {}, false);
